// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c1e1bcda","239":"4a1d6dcf","353":"17094f57","455":"13b0d565","513":"bf634598"}[chunkId] + ".chunk.js";
};